// React
import React from "react";
import PropTypes from "prop-types";

// Third Party Components
import Popover from '@material-ui/core/Popover';

// Styles
import { materialStyleGenerator } from "./index.material";

const MaterialPopoverComponent = ({ assignTriggerButton: TriggerButton, children }) => {
    const materialStyle = materialStyleGenerator()();

    const [anchorEl, setAnchorEl] = React.useState(null);

    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <TriggerButton aria-describedby={id} onClick={handleClick} />
            <Popover
                id={id}
                className={materialStyle.popover}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {children}
            </Popover>
        </>
    );
}

MaterialPopoverComponent.propTypes = {
    assignTriggerButton: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default MaterialPopoverComponent;